/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation } from "@i18n";
import { EstimateCostDatabaseItemsGridNew as EstimateCostDatabaseItems } from "@Features/estimation";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { itemListSources } from "@Actions/estimation";
import { getDefaultCurrencyDetailForProjectLevel } from "@Actions/Currency";
import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_ERROR } from "@Services/constants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@Reducers/index";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

function LinkBoqToTaskAndForm(props: any) {
  const { t } = useTranslation();
  // Route params enter from outside the type system; the backend route schema validates these ids.
  const params = useParams<{ projectId: ObjectIdString; contractId: ObjectIdString }>();
  const boqItemsRef = useRef<any>(null);
  const dispatch = useDispatch();
  const contractDetails = useSelector((state: RootState) => state.contractDetails);

  const estimateId = contractDetails.linkedEstimateVersion?.estimateId;
  const estimateVersionId = contractDetails.linkedEstimateVersion?.versionId;
  const contractId = params.contractId || props.contractId;
  const [currencyData, setCurrencyData] = useState<any>({});
  const [linkBoqItemBtnState, setLinkBoqItemBtnState] = useState(false);
  const [customBoqQuantity, setCustomBoqQuantity] = useState<any>({});
  const [autoPopulateState, setAutoPopulateState] = useState(false);

  const setInitialData = useCallback(async () => {
    const response = await getDefaultCurrencyDetailForProjectLevel({
      projectId: params.projectId!,
    });
    if (response.data.status) {
      setCurrencyData({
        currencyDetail: response.data.currencyDetail,
        symbolDetail: response.data.symbolDetail,
      });
    }
  }, [params.projectId]);

  useEffect(() => {
    setInitialData();
  }, [setInitialData]);

  const handleLinkBoqItemsClick = async () => {
    const selectedBoqData = [
      ...boqItemsRef.current.dataView.getAllSelectedItems().filter((record: any) => record && !record.__isDummy),
    ];
    let isAlreadyAdded = false;
    const boqItems = selectedBoqData.map((data: any) => {
      if (data.isAlreadyAddedInThisContract || data.isAlreadyAddedInThisForm || data.isAlreadyAddedInThisTask) {
        isAlreadyAdded = true;
      }
      const quantity = autoPopulateState ? data.availableQuantity : (customBoqQuantity[data.itemId] ?? 0);

      return {
        customQuantity: quantity,
        itemId: data.itemId,
        parentsList: data.parentsList,
      };
    });
    if (isAlreadyAdded) {
      dispatch(
        showToastNotification({
          content: t("One of the selected Item(s) is already added"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    } else if (!boqItems.length) {
      dispatch(
        showToastNotification({
          content: t("No BOQ Items have been selected"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    } else if (props.source == "gantt") {
      props.addBoqItemsCallBack({ boqItems });
    } else if (props.source == "forms") {
      props.addBoqItemsCallBack({ boqItems, autoPopulateState });
    }
  };

  const handleCancelBoqClick = () => {
    props.setShowBoqModal(false);
  };

  const boqHeaderContent = () => (
    <div className="  w-full flex justify-between rounded-md">
      <div className="">{t("BOQ Items")}</div>
    </div>
  );

  const setBtnState = (state: any) => {
    setLinkBoqItemBtnState(state);
  };

  const getCustomBoqQuantity = ({ itemId, value }: any) => {
    setCustomBoqQuantity((prev: any) => ({ ...prev, [itemId]: value }));
  };

  const boqModelContent = useCallback(
    () =>
      currencyData.currencyDetail && (
        <div className="mb-6 ms-6 me-6 flex overflow-hidden h-full">
          <EstimateCostDatabaseItems
            contractId={contractId}
            contractVersionId={contractDetails.versionId}
            estimateVersionId={estimateVersionId}
            estimateId={estimateId}
            getCustomBoqQuantity={getCustomBoqQuantity}
            setBtnState={setBtnState}
            ref={boqItemsRef}
            enableCheckboxSelector
            source={itemListSources.LINK_BOQ_ITEMS}
            currencyData={
              {
                _id: currencyData.currencyDetail._id,
                name: currencyData.currencyDetail.name,
                selectedSymbol: currencyData.symbolDetail,
              } as any
            }
            childParentMapper={{
              itemId: "itemId",
              parentId: "parentId",
            }}
            taskLinking={props.source == "gantt"}
            formLinking={props.source == "forms"}
            taskId={props.selectedTask?.originalTaskId}
            formId={props.formId}
            setAutoPopulateState={setAutoPopulateState as any}
          />
        </div>
      ),

    [
      currencyData,
      linkBoqItemBtnState,
      customBoqQuantity,
      contractDetails.versionId,
      contractId,
      estimateId,
      estimateVersionId,
      props.formId,
      props.selectedTask?.originalTaskId,
      props.source,
    ],
  );

  const boqFooterContent = () => (
    <div className=" flex gap-4">
      <ButtonComponent
        disabled={!linkBoqItemBtnState}
        buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
        onClick={handleLinkBoqItemsClick}
      >
        {t("Link")}
      </ButtonComponent>
      <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} onClick={handleCancelBoqClick}>
        {t("Cancel")}
      </ButtonComponent>
    </div>
  );

  const getBoqItemsList = () => (
    <ModalStateDialogComponent
      allowModalPadding={false}
      footerContent={boqFooterContent()}
      width="80%"
      height="80%"
      headerTitle={boqHeaderContent()}
      onCancel={handleCancelBoqClick}
      isVisible={props.showBoqModal}
      modelContent={boqModelContent()}
    />
  );

  const noEstimateLinkedWarningModal = () => (
    <ModalStateDialogComponent
      footerContent={<div />}
      width="30%"
      headerTitle={
        <div className="flex justify-between items-center w-full">
          <span>{t("No Estimate Linked")}</span>
        </div>
      }
      onCancel={handleCancelBoqClick}
      isVisible={props.showBoqModal}
      modelContent={<div className="">{t("No Estimate have been attached to this contract.")}</div>}
    />
  );

  return <div>{props.showBoqModal && estimateVersionId ? getBoqItemsList() : noEstimateLinkedWarningModal()}</div>;
}
export default LinkBoqToTaskAndForm;
